"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("swiper/react");
const swiper_1 = require("swiper");
require("swiper/css");
require("swiper/css/zoom");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ imageUrl, closeImageViewer, }) {
    const open = Boolean(imageUrl);
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog: closeImageViewer });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    return ((0, jsx_runtime_1.jsxs)(PhotoDialog, Object.assign({ fullScreen: true, open: open, onClick: closeImageViewer }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: closeImageViewer }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '24px', height: '24px' } }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ onClick: e => e.stopPropagation() }, { children: (0, jsx_runtime_1.jsx)(react_1.Swiper, Object.assign({ modules: [swiper_1.Zoom], grabCursor: true, zoom: true }, { children: (0, jsx_runtime_1.jsx)(react_1.SwiperSlide, Object.assign({ zoom: true }, { children: (0, jsx_runtime_1.jsx)("img", { src: imageUrl || '', style: { maxHeight: Math.min(window.innerWidth, 600) } }) })) })) }))] })));
}
exports.default = default_1;
const PhotoDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiIconButton-root {
    position: absolute;
    top: 24px;
    left: 24px;
    padding: 0;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 2;
  }
  .MuiDialog-scrollPaper {
    background-color: black;
  }
  .MuiDialog-paper {
    justify-content: center;
    background-color: black;
    max-width: 800px;
    overflow: hidden;
  }
  .swiper {
    width: 100%;
    overflow: visible;
  }
`;
